import AhaFormatter from './components/UI/Formatter.vue'
import AhaIcon from './components/UI/Icon.vue'
import AhaSvg from './components/UI/Svg.vue'
import AhaLogo from './components/UI/Logo.vue'
import AhaSpinner from './components/UI/Spinner.vue'

import AhaChat from './components/UI/live-chat/Chat.vue'
import AhaChatBox from './components/UI/live-chat/ChatBox.vue'
import AhaChatToggle from './components/UI/live-chat/ChatToggle.vue'

import AhaProfanityFilter from './utils/profanity-filter/ProfanityFilter.vue'
import AhaAvatar from './components/UI/Avatar.vue'
import AhaProgressCircle from './components/UI/ProgressCircle.vue'
import AhaLogoLoader from './components/UI/LogoLoader.vue'
import StarRating from './components/UI/StarRating.vue'
import AhaSkeletonLoader from './components/UI/SkeletonLoader.vue'
import AhaButton from './components/UI/Button.vue'
import AhaMultiStateSwitch from './components/UI/MultiStateSwitch.vue'
import AhaReconnecting from './components/UI/Reconnecting.vue'
import AhaAntdButton from './components/UI/button/AntdButton.vue'

// package
import { version } from '../package.json'
import './AhaCommon'

const install = (Vue) => {
  Vue.component('AhaFormatter', AhaFormatter)
  Vue.component('AhaIcon', AhaIcon)
  Vue.component('AhaSvg', AhaSvg)
  Vue.component('AhaLogo', AhaLogo)
  Vue.component('AhaChat', AhaChat)
  Vue.component('AhaChatBox', AhaChatBox)
  Vue.component('AhaChatToggle', AhaChatToggle)
  Vue.component('AhaSpinner', AhaSpinner)
  Vue.component('AhaProfanityFilter', AhaProfanityFilter)
  Vue.component('AhaAvatar', AhaAvatar)
  Vue.component('AhaProgressCircle', AhaProgressCircle)
  Vue.component('AhaLogoLoader', AhaLogoLoader)
  Vue.component('StarRating', StarRating)
  Vue.component('AhaSkeletonLoader', AhaSkeletonLoader)
  Vue.component('AhaButton', AhaButton)
  Vue.component('AhaMultiStateSwitch', AhaMultiStateSwitch)
  Vue.component('AhaReconnecting', AhaReconnecting)
  Vue.component('AhaAntdButton', AhaAntdButton)
}

export default {
  install,
  version,
}
